<template>
  <div :data-testid="TEST_ID.ARCHIVOS.CARD_ITEM" :data-archivo-id="archivo.Id">
    <el-card >
      <el-row :gutter="20" class="cardContent">
        <!-- Iconos -->
        <el-col :span="2">
          <el-row v-if="archivo.Es_archivo">
            <div class="iconContainer" :data-testid="TEST_ID.ARCHIVOS.CARD_DOWNLOAD_BUTTON" @click="archivo.Tipo_archivo == 1 ? downloadArchivo() : abrirEnlace()">
              <el-tooltip class="item" effect="dark" :content="archivo.Tipo_archivo == 1 ? $t('ARCHIVOS_descargar') : $t('ARCHIVOS_abrirLink')" placement="left-start">
                <el-icon><component :is="archivo.Tipo_archivo == 1 ? 'Download' : 'TopRight'" /></el-icon>
              </el-tooltip>
            </div>
          </el-row>
          <el-row v-if="esBusqueda">
            <div class="iconContainer" :data-testid="TEST_ID.ARCHIVOS.CARD_EDIT_BUTTON" @click="editarArchivo">
              <el-tooltip class="item" effect="dark" :content="$t('GENERAL_editBtn')" placement="left-start">
                <el-icon><Edit /></el-icon>
              </el-tooltip>
            </div>
          </el-row>
          <el-row v-if="esBusqueda">
            <div class="iconContainer" :data-testid="TEST_ID.ARCHIVOS.CARD_DELETE_BUTTON" @click="borrar">
              <el-tooltip class="item" effect="dark" :content="$t('GENERAL_deleteBtn')" placement="left-start">
                <el-icon><Delete /></el-icon>
              </el-tooltip>
            </div>
          </el-row>          
        </el-col>
        <!-- Datos -->
        <el-col :span="20">
          <el-row>
            <el-col :span="8">
              <span class="greyLabel">{{$t('ARCHIVOS_nombre')}}:</span>
            </el-col>
            <el-col :span="16">
              <div class="blackLabel" :data-testid="TEST_ID.ARCHIVOS.CARD_NAME">{{archivo.Nombre}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span class="greyLabel">{{$t('ARCHIVOS_fecha_creacion')}}:</span>
            </el-col>
            <el-col :span="16">
              <div class="blackLabel" :data-testid="TEST_ID.ARCHIVOS.CARD_CREATED_DATE">{{ $filters.formatDate(archivo.Fecha_creacion) }}</div>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="8">
              <span class="greyLabel">{{$t('ARCHIVOS_path')}}:</span>
            </el-col>
            <el-col :span="16">
              <div class="blackLabel">{{archivo.Path}}</div>
            </el-col>            
          </el-row> -->
          <el-row>
            <el-col :span="8">
              <span class="greyLabel">{{$t('ARCHIVOS_publico')}}:</span>
            </el-col>
            <el-col :span="16">
              <div class="blackLabel" :data-testid="TEST_ID.ARCHIVOS.CARD_PUBLIC">{{esPublico}}</div>
            </el-col>            
          </el-row>
          
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { showError } from '../Mensaje'
import TEST_ID from '@/testIds.json'
export default {
  name: "ArchivoCard",
  props: {
    archivo: Object,
    esBusqueda: Boolean 
  },
  data() {
    return {
      TEST_ID,
      opened: false,
    };
  },
  computed: 
  {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      perfiles: state => state.sesion.resultadoAutenticacion.Perfiles
    }),
    esPublico()
    {
      return this.archivo.Publico == true? this.$t('GENERAL_si'): this.$t('GENERAL_no')
    }
  },
  methods: {
    
    editarArchivo(event) {
      event.stopPropagation();
      this.$emit("editar", this.archivo.Id);
    },

    borrar()
    {
      this.$emit("borrarArchivo",this.archivo.Id,this.archivo.Nombre,this.archivo.Es_archivo);
    },
    abrirEnlace()
    {
      // pido la url del enlace
      this.$store.dispatch('archivos/getLink', { idArchivo: this.archivo.Id }).then(response => { 
        console.log(response);
        window.open(response, '_blank');  
      }).catch(() => showError(this.$t('ARCHIVOS_error_descarga')))
    },
    downloadArchivo() 
    {
      //armo el payload
      let payload = {
        idUsuario: this.idUsuario,
        idPerfiles: this.perfiles.map(x => x.Id),
        idNodo: this.archivo.Id,   
      }
      //debugger;
      // descargo el archivo exportado
      this.$store.dispatch('archivos/downloadFile', payload)
      .then(response => 
      {   
        // obtengo el content type y el file name
        let mimeType = response.headers["content-type"]
        let contentDisposition = response.headers["content-disposition"]
        let fileName = contentDisposition.split("; filename=")[1]
        fileName = fileName.replace(/"/g, "");
        fileName = decodeURIComponent(fileName)

        // genero un blob con la respuesta
        let blob = new Blob([response.data], { type: mimeType });
        
        // descargo el archivo
        if (navigator.msSaveOrOpenBlob) 
        {
            navigator.msSaveBlob(blob);
        } 
        else 
        {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.target = '_blank'
            link.setAttribute('download', fileName);
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
      }).catch(() => showError(this.$t('ARCHIVOS_error_descarga')))
    }
  }
}

</script>

<style scoped>
.username {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
}
.tag {
  position: absolute;
  top: 18px;
  right: 10px;
}
.triangleRight,
.triangleDown {
  width: 0;
  height: 0;
  border-style: solid;
  cursor: pointer;
}
.triangleRight {
  border-width: 8px 0 8px 13.9px;
  border-color: transparent transparent transparent var(--main-color);
}
.triangleDown {
  border-width: 13.9px 8px 0 8px;
  border-color: var(--main-color) transparent transparent transparent;
}

.iconContainer {
  cursor: pointer;
  font-size: 19px;
}

.iconContainer.checkContainer {
  position: absolute;
  top: -12.5px;
  right: -1px;
  background-color: var(--main-color);
  border-radius: 20px;
  width: 30px;
  height: 30px;
  color: white;
}

.iconContainer.checkContainer > .el-icon {
  padding: 5px;
}
.cardBody {
  padding-left: 25px;
}

.cardContent {
  text-align: left !important;
  margin-top: 8px;
}
.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}
</style>
